/* eslint-disable @typescript-eslint/no-explicit-any */
import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";
import type { TableSortValue } from "@src/shared/constants/sort-order.constants";

type DeeplinkType = '' | 'event' | 'service';
interface GetDeeplinksParams {
  page?: number;
  pageSize?: number;
  search?: string;
  type?: DeeplinkType;
  orderBy?: string;
  orderDirection?: TableSortValue;
  [key: string]: any;
}



export class DeeplinkService {
  async getDeeplinks(query: GetDeeplinksParams) {
    return apiService.get("/deeplinks", { params: sanitizeQueryParams(query) });
  }

  async getDeeplink(id: string | number, type: "service" | "event") {
    return apiService.get(`/deeplinks/${id}`, { params: { type } });
  }

  async createDeeplink(data: any) {
    return apiService.post("/deeplinks", data);
  }

  async updateDeeplink(id: string | number, data: any, type: 'service' | 'event') {
  return apiService.put(`/deeplinks/${id}`, data, {
    params: { type },
  });
}

  async deleteDeeplink(id: string | number, type: "service" | "event") {
    return apiService.delete(`/deeplinks/${id}`, { params: { type } });
  }

  async getCategoriesDropdown() {
    return apiService.get("/deeplinks/categories-dropdown");
  }

  async getBusinessesDropdown() {
    return apiService.get("/deeplinks/businesses-dropdown");
  }
}

export const deeplinkService = new DeeplinkService();
